const AUTH_REQUEST = "AUTH_REQUEST";
const VERIFY_OTP = "VERIFY_OTP";
const REFRESH_TOKEN = "REFRESH_TOKEN";
const DASHBOARD_CONFIG = "DASHBOARD_CONFIG";
const DASHBOARD_WEEKLY_CONTEST = "DASHBOARD_WEEKLY_CONTEST";
const DASHBOARD_MONTHLY_CONTEST = "DASHBOARD_MONTHLY_CONTEST";
const DASHBOARD_DAILY_CONTEST = "DASHBOARD_DAILY_CONTEST";
const LEADERBOARD_TABLE_DATA = "LEADERBOARD_TABLE_DATA";
const LEADERBOARD_HISTORY_DATA = "LEADERBOARD_HISTORY_DATA";
const MONTHLY_CHART_NAME = "MONTHLY_CHART_NAME";
const MONTHLY_PARTICULAR_CHART_DATA = "MONTHLY_PARTICULAR_CHART_DATA";
const LEAVE_DETAILS = 'LEAVE_DETAILS';
const QUERY_EMPLOYEE_DETAILS = 'QUERY_EMPLOYEE_DETAILS';
const APPLY_LEAVE = 'APPLY_LEAVE';
const APPLY_LEAVE_HISTORY = 'APPLY_LEAVE_HISTORY';
const SELECTED_CARD_DETAILS = 'SELECTED_CARD_DETAILS';
const CANCEL_LEAVE = 'CANCEL_LEAVE';
const SUBORDINATE_SPOT_REWARD = 'SUBORDINATE_SPOT_REWARD';
const SPOT_REWARD_AVAILABLE_COINS = 'SPOT_REWARD_AVAILABLE_COINS';
const SPOT_REWARD_VIEWED_USER_DATA = 'SPOT_REWARD_VIEWED_USER_DATA';
const SEND_REWARD_COINS = 'SEND_REWARD_COINS';
const GET_DASHBOARD_LASTUPDATED = 'GET_DASHBOARD_LASTUPDATED';
const GET_LEADERBOARD_LASTUPDATED = 'GET_LEADERBOARD_LASTUPDATED';
const GET_UPLOADFILE_OBJECT_ID = 'GET_UPLOADFILE_OBJECT_ID';
const DELETE_LEAVE_UPLOADEDFILE = 'DELETE_LEAVE_UPLOADEDFILE';
const GET_ATTENDANCE_REQUEST_DATA = 'GET_ATTENDANCE_REQUEST_DATA';
const POST_ATTENDANCE_APPROVE_DATA = 'POST_ATTENDANCE_APPROVE_DATA';
const GET_LEAVE_REQUEST_DATA = 'GET_LEAVE_REQUEST_DATA';
const POST_LEAVE_APPROVE_DATA = 'POST_LEAVE_APPROVE_DATA';
const GET_ATTENDANCE_HISTORY_DATA = 'GET_ATTENDANCE_HISTORY_DATA';
const POST_ATTENDANCE_REJECT_DATA = 'POST_ATTENDANCE_REJECT_DATA';
const POST_LEAVE_REJECT_DATA = 'POST_LEAVE_REJECT_DATA';
const GET_LEAVE_HISTORY_DATA = 'GET_LEAVE_HISTORY_DATA';
const GET_WEEKOFF_SUBORDINATE_DATA = 'GET_WEEKOFF_SUBORDINATE_DATA';
const POST_WEEKOFF_SUBORDINATE_DATA = 'POST_WEEKOFF_SUBORDINATE_DATA';
const GET_REGISTER_ASSET_PURCHASE_DATA = 'GET_REGISTER_ASSET_PURCHASE_DATA';
const GET_REGISTER_ASSET_STORE_DATA = 'GET_REGISTER_ASSET_STORE_DATA';
const POST_REGISTER_ASSET_VERIFY_OTP_DATA = 'POST_REGISTER_ASSET_VERIFY_OTP_DATA';
const POST_REGISTER_ASSET_OTP_VERIFIED_DATA = 'POST_REGISTER_ASSET_OTP_VERIFIED_DATA';
const GET_REGISTER_ASSET_QR_CODE = 'GET_REGISTER_ASSET_QR_CODE';
const GET_REGISTER_ASSET_REGISTERED_DOWNLOAD_DATA = 'GET_REGISTER_ASSET_REGISTERED_DOWNLOAD_DATA';
const SELECTED_DATA_INCREMENT = 'SELECTED_DATA_INCREMENT';
const SELECTED_DATA_DECREMENT = "SELECTED_DATA_DECCREMENT";
const GET_AGREEMENT_LATEST_DATA = "GET_AGREEMENT_LATEST_DATA";
const IS_CHECKED = "IS_CHECKED";
const IS_FILTER = "IS_FILTER";
const SHOW_MODAL_ASSETGROUP = "SHOW_MODAL_ASSETGROUP";
const HIDE_MODAL_ASSETGROUP = "HIDE_MODAL_ASSETGROUP";
const SHOW_MODAL_DOWNLOAD = "SHOW_MODAL_DOWNLOAD";
const HIDE_MODAL_DOWNLOAD = "HIDE_MODAL_DOWNLOAD";
const POST_AGREEMENT_UPLOAD_DATA = 'POST_AGREEMENT_UPLOAD_DATA';
const GET_AGREEMENT_UPLOADFILE_OBJECT_DATA = 'GET_AGREEMENT_UPLOADFILE_OBJECT_DATA';
const GET_ISSUED_STORE_DOWNLOAD_QR = 'GET_ISSUED_STORE_DOWNLOAD_QR';
const GET_OR_CODE_ISSUED_STORE = 'GET_OR_CODE_ISSUED_STORE';
const IS_CHECKED_ITEMS = 'IS_CHECKED_ITEMS';
const IS_CHECKED_ALL_ITEMS = 'IS_CHECKED_ALL_ITEMS';
const HIDE_MODAL_SELECT_ITEM = 'HIDE_MODAL_SELECT_ITEM';
const SHOW_MODAL_SELECT_ITEM = 'SHOW_MODAL_SELECT_ITEM';
const SELECT_STORE_DATA = 'SELECT_STORE_DATA';
const HIDE_MODAL_SELECT_STORE = 'HIDE_MODAL_SELECT_STORE';
const SHOW_MODAL_SELECT_STORE = 'SHOW_MODAL_SELECT_STORE';
const SELECTED_ASSET_INFO_DE_REGISTER = 'SELECTED_ASSET_INFO_DE_REGISTER';
const DELETE_UPLOADFILE_DE_REGISTER = 'DELETE_UPLOADFILE_DE_REGISTER';
const DE_REGISTER_ASSET_LIST = 'DE_REGISTER_ASSET_LIST';
const DELETE_DE_REGISTER_ASSET_LIST = 'DELETE_DE_REGISTER_ASSET_LIST';
const GET_OTP_DE_REGISTER_ASSET = 'GET_OTP_DE_REGISTER_ASSET';
const POST_DE_REGISTER_ASSET_OTP_VERIFIED_DATA = 'POST_DE_REGISTER_ASSET_OTP_VERIFIED_DATA';
const GET_FILTERED_DE_REGISTER_ASSET_DATA = 'GET_FILTERED_DE_REGISTER_ASSET_DATA';
const CLEAR_DE_REGISTER_ASSET_STATE = 'CLEAR_DE_REGISTER_ASSET_STATE';
const DELETE_FILETR_DE_REG_ASSET_DATA = 'DELETE_FILETR_DE_REG_ASSET_DATA';
const IS_IOS_DEVICE = 'IS_IOS_DEVICE';
const GET_MY_CERTIFICATE_DATA = 'GET_MY_CERTIFICATE_DATA';
const POST_EFFECTIVE_DATE_DATA = 'POST_EFFECTIVE_DATE_DATA';
const ADD_EFFECTIVEDATE_REGISTERED_ASSET = 'ADD_EFFECTIVEDATE_REGISTERED_ASSET';
const CLEAR_EFFECTIVE_DATE = 'CLEAR_EFFECTIVE_DATE';
const GET_EMPLOYEE_HELPDESK_CATEGORY = 'GET_EMPLOYEE_HELPDESK_CATEGORY';
const GET_EMPLOYEE_HELPDESK_SUB_CATEGORY = 'GET_EMPLOYEE_HELPDESK_SUB_CATEGORY';
const POST_EMPLOYEE_HELPDESK_CATEGORY = 'POST_EMPLOYEE_HELPDESK_CATEGORY';
const POST_EMPLOYEE_HELPDESK_SUB_CATEGORY = 'POST_EMPLOYEE_HELPDESK_SUB_CATEGORY';
const POST_CREATE_TICKET_EMPLOYEE_HELPDESK = 'POST_CREATE_TICKET_EMPLOYEE_HELPDESK';
const GET_EMPLOYEE_TICKETS = 'GET_EMPLOYEE_TICKETS';
const POST_UPLOAD_FILE = 'POST_UPLOAD_FILE';
const POST_CREATE_TICKET_REPLY = 'POST_CREATE_TICKET_REPLY';
const POST_GET_EMP_TICKET = 'POST_GET_EMP_TICKET';
const POST_UPDATE_TICKET_REPLY = 'POST_UPDATE_TICKET_REPLY';
const POST_GET_TICKET_REPLY = 'POST_GET_TICKET_REPLY';
const POST_UPDATE_TICKET_STATUS = 'POST_UPDATE_TICKET_STATUS';
const POST_DELETE_TICKET_REPLY = 'POST_DELETE_TICKET_REPLY';
const POST_UPLOAD_FILE_CHAT = 'POST_UPLOAD_FILE_CHAT';
const POST_CREATE_ATTACHMENT = 'POST_CREATE_ATTACHMENT';
const POST_DELETE_ATTACHMENT = 'POST_DELETE_ATTACHMENT';
const GET_TICKET_DATA = 'GET_TICKET_DATA';
const GET_SPOT_REWARDS_DATA = 'GET_SPOT_REWARDS_DATA';
const GET_ASSET_UPLOADFILE_OBJECT_DATA = "GET_ASSET_UPLOADFILE_OBJECT_DATA";
const SET_PURCHASED_DATA = 'SET_PURCHASED_DATA';
const SET_SELECT_PURCHASED_DATA = 'SET_SELECT_PURCHASED_DATA';
const GET_CHECKLIST_STORE_DATA = 'GET_CHECKLIST_STORE_DATA';
const GET_CHECKLIST_DATA = 'GET_CHECKLIST_DATA';
const IS_CHECKED_DATA = 'IS_CHECKED_DATA';
const GET_SCHEDULE_DATA = 'GET_SCHEDULE_DATA';
const POST_ADD_BULK_SCHEDULE = 'POST_ADD_BULK_SCHEDULE';
const POST_UPDATE_SCHEDULE = 'POST_UPDATE_SCHEDULE';
const GET_RESCHEDULE_HISTORY = 'GET_RESCHEDULE_HISTORY';
const SAVE_CHECKLIST_DATE = 'SAVE_CHECKLIST_DATE';
const HISTORY_REWARDS_DATA = 'HISTORY_REWARDS_DATA';

export {
    HISTORY_REWARDS_DATA, SAVE_CHECKLIST_DATE, GET_RESCHEDULE_HISTORY, POST_UPDATE_SCHEDULE, POST_ADD_BULK_SCHEDULE, GET_SCHEDULE_DATA, IS_CHECKED_DATA, GET_CHECKLIST_DATA, GET_CHECKLIST_STORE_DATA, SET_SELECT_PURCHASED_DATA, SET_PURCHASED_DATA, GET_SPOT_REWARDS_DATA, GET_ASSET_UPLOADFILE_OBJECT_DATA, GET_TICKET_DATA, POST_DELETE_ATTACHMENT, POST_CREATE_ATTACHMENT, POST_UPLOAD_FILE_CHAT, POST_DELETE_TICKET_REPLY, POST_UPDATE_TICKET_STATUS, POST_UPDATE_TICKET_REPLY, POST_GET_EMP_TICKET, POST_CREATE_TICKET_REPLY, POST_UPLOAD_FILE, POST_GET_TICKET_REPLY, GET_EMPLOYEE_TICKETS, POST_CREATE_TICKET_EMPLOYEE_HELPDESK, POST_EMPLOYEE_HELPDESK_SUB_CATEGORY, POST_EMPLOYEE_HELPDESK_CATEGORY, GET_EMPLOYEE_HELPDESK_SUB_CATEGORY, GET_EMPLOYEE_HELPDESK_CATEGORY, CLEAR_EFFECTIVE_DATE, ADD_EFFECTIVEDATE_REGISTERED_ASSET, POST_EFFECTIVE_DATE_DATA, GET_MY_CERTIFICATE_DATA, IS_IOS_DEVICE, DELETE_FILETR_DE_REG_ASSET_DATA, CLEAR_DE_REGISTER_ASSET_STATE, GET_FILTERED_DE_REGISTER_ASSET_DATA, POST_DE_REGISTER_ASSET_OTP_VERIFIED_DATA, GET_OTP_DE_REGISTER_ASSET, DELETE_DE_REGISTER_ASSET_LIST, DE_REGISTER_ASSET_LIST, DELETE_UPLOADFILE_DE_REGISTER, SELECTED_ASSET_INFO_DE_REGISTER, HIDE_MODAL_SELECT_STORE, SHOW_MODAL_SELECT_STORE, SELECT_STORE_DATA, SHOW_MODAL_SELECT_ITEM, HIDE_MODAL_SELECT_ITEM, HIDE_MODAL_DOWNLOAD, SHOW_MODAL_DOWNLOAD, SHOW_MODAL_ASSETGROUP, HIDE_MODAL_ASSETGROUP, IS_CHECKED_ALL_ITEMS, IS_CHECKED_ITEMS, GET_OR_CODE_ISSUED_STORE, GET_ISSUED_STORE_DOWNLOAD_QR, GET_AGREEMENT_UPLOADFILE_OBJECT_DATA, POST_AGREEMENT_UPLOAD_DATA, IS_FILTER, IS_CHECKED, GET_AGREEMENT_LATEST_DATA, SELECTED_DATA_DECREMENT, SELECTED_DATA_INCREMENT,
    GET_REGISTER_ASSET_REGISTERED_DOWNLOAD_DATA, GET_REGISTER_ASSET_QR_CODE, POST_REGISTER_ASSET_OTP_VERIFIED_DATA, POST_REGISTER_ASSET_VERIFY_OTP_DATA, VERIFY_OTP, DELETE_LEAVE_UPLOADEDFILE, GET_UPLOADFILE_OBJECT_ID, GET_LEADERBOARD_LASTUPDATED, GET_DASHBOARD_LASTUPDATED, SEND_REWARD_COINS, SPOT_REWARD_VIEWED_USER_DATA, SPOT_REWARD_AVAILABLE_COINS, SUBORDINATE_SPOT_REWARD, CANCEL_LEAVE, APPLY_LEAVE, SELECTED_CARD_DETAILS, APPLY_LEAVE_HISTORY, QUERY_EMPLOYEE_DETAILS, LEAVE_DETAILS, MONTHLY_PARTICULAR_CHART_DATA, MONTHLY_CHART_NAME, AUTH_REQUEST, REFRESH_TOKEN, DASHBOARD_CONFIG, DASHBOARD_WEEKLY_CONTEST, DASHBOARD_DAILY_CONTEST, DASHBOARD_MONTHLY_CONTEST, LEADERBOARD_TABLE_DATA, LEADERBOARD_HISTORY_DATA, GET_ATTENDANCE_REQUEST_DATA, POST_ATTENDANCE_APPROVE_DATA, GET_LEAVE_REQUEST_DATA, POST_LEAVE_APPROVE_DATA, GET_ATTENDANCE_HISTORY_DATA, POST_ATTENDANCE_REJECT_DATA, POST_LEAVE_REJECT_DATA, GET_LEAVE_HISTORY_DATA, GET_WEEKOFF_SUBORDINATE_DATA, POST_WEEKOFF_SUBORDINATE_DATA, GET_REGISTER_ASSET_PURCHASE_DATA, GET_REGISTER_ASSET_STORE_DATA
}




